import PropTypes from "prop-types";
import styles from "./BreadCrumb.module.scss";
import { Link, Nav, useDispatch,useRouter } from "../DependencyHelper";
import labels from "../../../config/labels";

import {
  componentResize,
  getCookieValue,
  internalUrl,
  showSpinner,
  hideSpinner
} from "../../../utils/helperServices";

import { BREADCRUMB_SELECT } from "../../../Redux/actionTypes";

const BreadCrumb = ({ list, title, replacePageTitle }) => {

  const isMobile = componentResize();
  const itemsBefore =
    labels.BreadCrumbLabels.items_display_before_collapser_mbl;
  const itemsAfter = labels.BreadCrumbLabels.items_display_after_collapser_mbl;
  var breadcrumbList = [];
  var currentPage = {};
  var lastItem;
  const router=useRouter();
  const dispatch=useDispatch();

  const isMiniApp = getCookieValue("miniApp") === "true";

  const handleClick=(url)=>{
    showSpinner();
    dispatch({type:BREADCRUMB_SELECT,payload:true})
    if(internalUrl(url).url==="/"){
      if(typeof window!==undefined){
        const origin =window.location.origin;
        // .then(()=>{
        window.location.assign(origin);
        hideSpinner();
        // window.lo
        // })
      }
    }
    else {
      router.push(internalUrl(url).url)
        .then(()=>{
          hideSpinner();

        })
    }

  }
  function handleBreadCrumbMobile(breadcrumbList) {
    if (
      isMobile &&
      breadcrumbList.length > labels.BreadCrumbLabels.max_display_items_mbl
    ) {
      breadcrumbList.splice(
        0,
        breadcrumbList.length,
        ...breadcrumbList.slice(0, itemsBefore),
        { title: labels.BreadCrumbLabels.lbl_hidden_breadCrumb_for_mobile },
        ...breadcrumbList.slice(
          breadcrumbList.length - itemsAfter,
          breadcrumbList.length
        )
      );
    }
    lastItem = breadcrumbList.length - 1;
    return breadcrumbList;
  }

  if (list) {
    var totalKeys = Object.keys(list).length;

    // Mapping current page object into currentPage
    if (totalKeys > 0) {
      currentPage = Object.values(list)[totalKeys - 1];
    }

    Object.entries(list).forEach(value => {
      let replacedTitle =
        title && value[1].url === currentPage.url ? title : null;
      let replacePageTitleBool =
        replacePageTitle && value[1].url === currentPage.url ? true : false;

      let matchedRoute = {
        url: value[1].url,
        title: value[0],
        replacedTitle: replacedTitle,
        replacePageTitle: replacePageTitleBool
      };
      breadcrumbList.push(matchedRoute);
    });

    lastItem = breadcrumbList.length - 1;
  }

  return isMiniApp || breadcrumbList.length === 0 ||
  (breadcrumbList.length === 1 && breadcrumbList[0].url == "/") ? (
    ""
  ) : (
    <Nav className={`${styles["breadcrumb-wrapper"]}`}>
      <ol className={`${styles["breadcrumb-list"]}`}>
        {handleBreadCrumbMobile(breadcrumbList).map((bcrumb, index) => {
          return (
            <li
              className={`${styles["breadcrumb-item"]}`}
              key={index}
              id={`${index}_${bcrumb.title}`}
            >
              {lastItem !== index && bcrumb.url ? (
                <a  id={`${index}_${bcrumb.replacePageTitle ? bcrumb.replacedTitle : bcrumb.title}`} onClick={()=>handleClick(bcrumb.url)}>                    {bcrumb.replacePageTitle
                  ? bcrumb.replacedTitle
                  : bcrumb.title}
                </a>
              ) : bcrumb.replacePageTitle ? (
                <span id={`${index}_${bcrumb.replacedTitle}`}>{bcrumb.replacedTitle}</span>
              ) : (
                <span id={`${index}_${bcrumb.title}`}>{bcrumb.title}</span>
              )}
            </li>
          );
        })}
      </ol>
    </Nav>
  );
};

BreadCrumb.defaultProps = {
  list: null,
  title: "",
  replacePageTitle: false
};

BreadCrumb.propTypes = {
  list: PropTypes.object,
  title: PropTypes.string,
  replacePageTitle: PropTypes.bool
};

export default BreadCrumb;
